import ReactGA from "react-ga4";

ReactGA.initialize("G-3Z79YS9TGN");

export const trackRoute = (page) => {
    ReactGA.set({ page: page });
    ReactGA.send({ hitType: "pageview", page: page });
}